export type Locale = 'it' | 'en';

export const defaultLocale: Locale = 'it';
export const supportedLocales: Locale[] = ['it', 'en'];

export const localeLabels: Record<Locale, string> = {
  it: 'IT',
  en: 'EN',
};

export const ogLocales: Record<Locale, string> = {
  it: 'it_IT',
  en: 'en_US',
};

export const menuPdfUrls: Record<Locale, string> = {
  it: '/menu-braceesapori-8.pdf',
  en: '/menu-braceesapori-8_en.pdf',
};

export const newMenuPdfUrls: Record<Locale, string> = {
  it: '/menu_ale_ita.pdf',
  en: '/menu_ale_ingle.pdf',
};

export const dateLocales: Record<Locale, string> = {
  it: 'it-IT',
  en: 'en-GB',
};

/** Logical path → locale-specific URL (when EN slug differs from IT) */
export const localizedPathAliases: Record<string, Record<Locale, string>> = {
  '/accessibilita': { it: '/accessibilita', en: '/en/accessibility' },
};
